import React, { useState } from "react";
import CustomInput from "../../common/CustomInput";
import StaffProfileDropdown from "../../common/StaffProfileDropdown";

const AddEducationModal = ({
  onClose,
  onAdd,
  universityOptions = [],
  degreeOptions = [],
}) => {
  const [formData, setFormData] = useState({
    university: "",
    degree: "",
    startYear: "",
    endYear: "",
    customUniversity: "",
    customDegree: "",
    document: null,
  });

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Get the selected university and degree labels
    const selectedUniversity = universityOptions.find(
      (option) => option.value === formData.university
    );
    const selectedDegree = degreeOptions.find(
      (option) => option.value === formData.degree
    );

    const universityName =
      formData.university === "other"
        ? formData.customUniversity
        : selectedUniversity
        ? selectedUniversity.label
        : formData.university;
    const degreeName =
      formData.degree === "other"
        ? formData.customDegree
        : selectedDegree
        ? selectedDegree.label
        : formData.degree;

    const educationData = {
      university: universityName,
      degree: degreeName,
      startYear: formData.startYear,
      endYear: formData.endYear,
      document: formData.document,
    };

    onAdd(educationData);
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prev) => ({
        ...prev,
        document: file,
      }));
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-2xl mx-4">
        {/* Header */}
        <div className="flex justify-between items-center border-b border-[#E6E6E6] pb-6 mb-6">
          <h2 className="text-[16px] font-bold text-[#3C3C3C]">
            ADD EDUCATION
          </h2>
          <div className="flex gap-2">
            <button
              onClick={onClose}
              className="px-4 py-2 border border-[#E6E6E6] bg-white text-[#1E1E1E] rounded-lg"
            >
              Cancel
            </button>
            <button
              onClick={handleSubmit}
              className="px-4 py-2 bg-[#2283FF] text-white rounded-lg"
            >
              Save
            </button>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          {/* University Name */}
          <div>
            <StaffProfileDropdown
              label="UNIVERSITY NAME"
              value={formData.university}
              onChange={(value) => handleInputChange("university", value)}
              options={universityOptions}
              placeholder="Select university"
            />
            {formData.university === "other" && (
              <CustomInput
                label="ADD UNIVERSITY NAME"
                value={formData.customUniversity}
                onChange={(e) =>
                  handleInputChange("customUniversity", e.target.value)
                }
                placeholder="Add university name here"
              />
            )}
          </div>

          {/* Degree */}
          <div>
            <StaffProfileDropdown
              label="DEGREE"
              value={formData.degree}
              onChange={(value) => handleInputChange("degree", value)}
              options={degreeOptions}
              placeholder="Add degree name"
            />
            {formData.degree === "other" && (
              <CustomInput
                label="ADD DEGREE NAME"
                value={formData.customDegree}
                onChange={(e) =>
                  handleInputChange("customDegree", e.target.value)
                }
                placeholder="Add degree name here"
              />
            )}
          </div>

          {/* Start Year and End Year */}
          <div className="grid grid-cols-2 gap-4">
            <CustomInput
              label="START YEAR"
              value={formData.startYear}
              onChange={(e) => handleInputChange("startYear", e.target.value)}
              placeholder="Add year here"
            />
            <CustomInput
              label="END YEAR"
              value={formData.endYear}
              onChange={(e) => handleInputChange("endYear", e.target.value)}
              placeholder="Add year here"
            />
          </div>

          {/* Upload Document Button */}
          <div>
            <button
              type="button"
              onClick={() =>
                document.getElementById("education-document").click()
              }
              className="w-fit px-4 py-2 border border-[#E6E6E6] bg-white text-[#1E1E1E] rounded-lg flex items-center gap-2 mt-2"
            >
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13 9V11.6667C13 12.0203 12.8595 12.3594 12.6095 12.6095C12.3594 12.8595 12.0203 13 11.6667 13H2.33333C1.97971 13 1.64057 12.8595 1.39052 12.6095C1.14048 12.3594 1 12.0203 1 11.6667V9M10.3333 4.33333L7 1M7 1L3.66667 4.33333M7 1V9"
                  stroke="#2C2C2C"
                  stroke-width="1.6"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              Upload document
            </button>
            <input
              id="education-document"
              type="file"
              onChange={handleFileUpload}
              className="hidden"
              accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
            />
            {formData.document && (
              <p className="text-sm text-gray-600 mt-2">
                Selected: {formData.document.name}
              </p>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddEducationModal;
